import template from "./one-bar-chart.html";
import {oneBarChartController} from "./one-bar-chart.controller";
import "./one-bar-chart.scss";

export const OneBarChartComponent = {
    template,
    controller: oneBarChartController,
    controllerAs: "chart",
    bindings: {
        data: "<",
        lines: "@"
    }
};
export default OneBarChartComponent;


// WEBPACK FOOTER //
// ./sources/components/charts/one-bar-chart/one-bar-chart.component.js